import { colors } from '../../colors';
var fiftyFiftyCard = {
  bgColorLight: colors.white,
  bgColorDark: colors.smoke,
  textColorDark: colors.smoke,
  textColorLight: colors.white,
  notFullBleed: true
};
export default fiftyFiftyCard;